t = require('views/internal/teacup-with-helpers')('org_prefs_vis')

module.exports = t.renderable (enterprise, visibility) ->
  t.div ->
    t.ul ->
      t.li { class: t.classify('team-setting-restriction-group': true) }, ->
        t.ul '.pop-over-list.checkable.green-check', { 'data-vis': visibility }, ->
          t.li { class: t.classify(active: enterprise.organizationPrefs.boardVisibilityRestrict[visibility] == undefined) }, ->
            t.a { href: '#', 'data-restriction': 'undefined' }, ->
              t.format 'let-team-admins-decide'
              t.span { class: 'sub-name' }, ->
                t.format 'team-admins-can-change'
          t.hr()
      t.li { class: t.classify('team-setting-restriction-group': true, disabled: enterprise.organizationPrefs.boardVisibilityRestrict[visibility] == undefined) }, ->
        t.p ->
          t.format ['enterprise', "who-can-create-#{ visibility }-boards"]
        t.p '.sub-name', ->
          t.format ['board-types-explanations', visibility]

        t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': visibility }, ->
          t.li { class: t.classify(active: enterprise.organizationPrefs.boardVisibilityRestrict[visibility] == 'org') }, ->
            t.a { href: '#', 'data-restriction': 'org' }, ->
              t.format 'any-organization-member'

          t.li { class: t.classify(active: enterprise.organizationPrefs.boardVisibilityRestrict[visibility] == 'admin') }, ->
            t.a { href: '#', 'data-restriction': 'admin' }, ->
              t.format 'only-organization-admins'

          t.li { class: t.classify(active: enterprise.organizationPrefs.boardVisibilityRestrict[visibility] == 'none') }, ->
            t.a { href: '#', 'data-restriction': 'none' }, ->
              t.format 'nobody'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_org_prefs_vis.coffee